import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import SideMenu from "../sideMenu";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Menu,
  Row,
  Space,
  Typography,
  Modal as AntdModal,
  Alert,
  Tag,
} from "antd";
import { tableIcons } from "../../../tableIcons";

import QueryString from "query-string";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import config from "../../../config";
import moment from "moment";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Radio,
  RadioGroup,
  TablePagination,
  TextField,
} from "@material-ui/core";
import { Form, Modal, Badge, Spinner } from "react-bootstrap";
import { EllipsisOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";
import { useNavigate, useLocation } from "react-router-dom";
import Title from "antd/es/typography/Title";
import CustomTable from "../../table";
import { BsCreditCard } from "react-icons/bs";
import { useAccess } from "../../../provider/AccessProvider";
import { VENDORACCESS } from "../../../utils/constant";
import ReturnBillModal from "./returnBill";
const { Text } = Typography;

const checkReturnedItems = (data) => {
  // console.log("data2323", data);
  if (data.billReturn?.length > 0) {
    const isFullyReturned = data.items.every((i) => i?.fullyReturned === true);
    return isFullyReturned ? (
      <Tag
        color="purple"
        style={{
          width: 120,
          textAlign: "center",
        }}
      >
        Fully Returned
      </Tag>
    ) : (
      <Tag
        color="magenta"
        style={{
          width: 120,
          textAlign: "center",
        }}
      >
        Partially Returned
      </Tag>
    );
    // }
  }
};

const VendorBillHistory = (props) => {
  const shopData = useSelector((state) => state.shopDetails);
  const [vendorId, setVendorId] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [billDetails, setBillDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [cancelBillModal, setCancelBillModal] = useState(false);
  const [reasonForCancellation, setReasonForCancellation] = useState("");
  const [billId, setBillId] = useState("");
  const currencyFormatter = useCurrency();
  const navigate = useNavigate();
  const location = useLocation();
  const country = useCountry();
  const [openModal, setOpenModal] = useState({
    show: false,
    data: {},
  });
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState({
    cash: "",
    upi: "",
    card: "",
  });
  const [cardType, setCardType] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [openHistory, setOpenHistory] = useState({
    show: false,
    data: {},
  });
  const access = useAccess(VENDORACCESS);

  console.log("shopData1987", shopData);

  const cancelBill = async () => {
    if (!reasonForCancellation) {
      return alert("Please choose reason for cancelation");
    }
    var body = {
      billId: billId,
      reason: reasonForCancellation,
      action: "vendorCancelBill",
    };

    setIsLoading(true);

    try {
      var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      res = await res.json();

      if (res.code === "ERROR") {
        alert(res.message);
        return;
      }
      setCancelBillModal(false);
      setIsLoading(false);
      setReasonForCancellation("");
      fetchVendorDetails(vendorId);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const menu = (data) => {
    const isFullyReturned = data.items.every((i) => i.fullyReturned === true);
    return (
      <Menu>
        {parseFloat(data.balanceAmount) > 0 && !isFullyReturned && (
          <Menu.Item
            style={{
              width: "150px",
            }}
            onClick={() =>
              setOpenModal({
                show: true,
                data: data,
              })
            }
            key="clear-pending"
          >
            Clear pending
          </Menu.Item>
        )}
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            if (!access.vendorViewDetails(false)) {
              return alert(
                "You don't have access, please contact admin and request for access"
              );
            }
            navigate({
              pathname: `/dashboard/vendor-management/bill-history`,
              search: `?id=${data.billId}`,
            });
          }}
          key="view"
        >
          View bill
        </Menu.Item>
        <ReturnBillModal data={data} refetch={fetchVendorDetails} />
      </Menu>
    );
  };

  const handleCancellBill = (data) => {
    if (!access.cancelBill()) {
      return;
    }
    setCancelBillModal(true);
    setBillId(data.billId);
  };

  useEffect(() => {
    if (shopData.shopId) {
      let params = QueryString.parse(location.search);
      fetchVendorDetails(params.id);
      setVendorId(params.id);
    }
  }, [shopData.shopId]);

  const fetchVendorDetails = async (id) => {
    var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
      method: "POST",
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        vendorId: id,
        shopId: shopData.shopId,
        action: "fetchVendorDetails",
      }),
    });
    res = await res.json();
    setIsLoading(false);
    if (res.code === "ERROR") {
      return alert(res.message);
    }
    setVendorDetails(res.data?.vendorData);
    setBillDetails(res.data.vendorBillDetails);
  };

  const columns = [
    {
      title: "Invoice number",
      width: "20%",
      defaultSort: "desc",
      render: (data) => {
        return (
          <>
            <div>{data.invoiceNumber}</div>{" "}
            <div> {checkReturnedItems(data)}</div>
          </>
        );
      },
    },
    {
      title: "Billing date",
      width: "20%",
      render: (data) => {
        return <>{moment(data.billingDate).format("DD-MM-YYYY")}</>;
      },
    },
    {
      title: "Total Bill Value",
      render: (data) => {
        return <> {currencyFormatter(data.totalBillValue)}</>;
      },
    },
    {
      title: "Amount paid",
      render: (data) => <> {currencyFormatter(data.amountPaid)}</>,
    },
    {
      title: "Amount pending",
      render: (data) => {
        return <> {currencyFormatter(data.balanceAmount)}</>;
      },
    },
    {
      title: "Returned Products Amount",
      render: (data) => {
        const amount = data.billReturn?.reduce(
          (acc, curr) => acc + parseFloat(curr.returnAmount),
          0
        );
        return <> {amount ? currencyFormatter(amount) : "-"}</>;
      },
    },
    {
      title: "Due date",
      render: (data) => {
        return (
          <>
            {data.dueDate
              ? moment(data.dueDate).format("DD-MM-YYYY")
              : "No Due"}
          </>
        );
      },
    },
    // {
    //   title: "Tax credit",
    //   render: (data) => {
    //     return <p> {currencyFormatter(data.taxCredit)}</p>;
    //   },
    // },
    {
      title: "Actions",
      render: (data) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button onClick={() => handleHistoryClick(data)} type="link">
              {" "}
              History
            </Button>
            <Dropdown
              getPopupContainer={(el) => el.parentNode}
              overlay={() => menu(data)}
              placement="right"
              arrow
            >
              <EllipsisOutlined
                style={{
                  fontSize: "1.5rem",
                  transform: "rotate(90deg)",
                  cursor: "pointer",
                }}
              />
            </Dropdown>
          </div>
        );
      },
    },
  ];
  const handleHistoryClick = (data) => {
    setOpenHistory({
      show: true,
      data: data,
    });
  };
  const handleConfirm = async () => {
    const pendingAmount = openModal.data.balanceAmount;
    const received =
      parseFloat(paymentMethod.cash || 0) +
      parseFloat(paymentMethod.upi || 0) +
      parseFloat(paymentMethod.card || 0);
    const diff = pendingAmount - received;
    if (!paymentMethod.card && !paymentMethod.cash && !paymentMethod.upi) {
      return alert("Please enter amount");
    }
    if (paymentMethod.card) {
      if (!cardType) {
        return alert("Please select card type");
      }
      if (!cardNumber) {
        return alert("Please enter card number");
      }
    }
    if (diff < 0) {
      return alert("Pending amount cannot be negative");
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${config.newApiGateway}/vendor/vendorManagement`,
        {
          method: "post",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            billId: openModal.data.billId,
            paymentMethod: paymentMethod,
            ...(paymentMethod.card && {
              cardType: cardType,
              cardNumber: cardNumber,
            }),
            updatedBy: shopData.phoneNumber,
            shopId: shopData.shopId,
            updatedByName: shopData.empId
              ? shopData.employeeName
              : "Shop Owner",
            action: "vendorClearPending",
          }),
        }
      );
      const data = await response.json();
      if (data.code === "SUCCESS") {
        const updatedItem = data.data.Attributes;
        console.log("updatedItem", updatedItem.billId);
        setBillDetails((prev) => {
          const updatedBillList = prev.map((item) => {
            if (item.billId === updatedItem.billId) {
              return {
                ...item,
                ...updatedItem,
              };
            }
            return item;
          });
          return updatedBillList;
        });
        setOpenModal({
          show: false,
          data: {},
        });
        setPaymentMethod({
          cash: "",
          upi: "",
          card: "",
        });
        setCardType("");
        setCardNumber("");
        alert("Bill cleared successfully");
      }
      console.log("data", data);
      //if(data.)
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (!access.viewDetails(false)) {
    return (
      <Alert
        style={{
          padding: "20px",
          textAlign: "center",
        }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }
  return (
    <>
      <div>
        <Card
          bodyStyle={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
          style={{
            marginBottom: 20,
          }}
        >
          <Space direction="vertical">
            <Title
              style={{
                margin: 0,
              }}
              level={5}
            >
              Name:
              <Text type="secondary">
                {vendorDetails ? vendorDetails.userName : ""}
              </Text>
            </Title>
            <Title
              style={{
                margin: 0,
              }}
              level={5}
            >
              Mobile Number:{" "}
              <Text type="secondary">
                {vendorDetails ? vendorDetails.userPhoneNumber : ""}
              </Text>
            </Title>
          </Space>
          <Button
            type="primary"
            style={{
              marginLeft: "auto",
            }}
            onClick={() => {
              if (!access.addBill()) {
                return;
              }
              navigate(
                {
                  pathname: `/dashboard/vendor-management/add-bill`,
                  search: `?id=${vendorId}`,
                },
                {
                  state: {
                    vendorDetails,
                  },
                }
              );
            }}
          >
            Add Bill
          </Button>
        </Card>

        <CustomTable
          columns={columns}
          title="Bills"
          data={billDetails}
          style={{
            minHeight: "calc(100vh - 365px)",
          }}
          emptyContainerStyle={{
            minHeight: "calc(100vh - 300px)",
          }}
          loading={isLoading}
        />
        {/* <div style={{ margin: "20px" }} className="cm-table">
          <Row
            style={{
              width: "100%",
            }}
          >
            <Col span={8}>
              <h5>Name: {vendorDetails ? vendorDetails.userName : ""}</h5>
            </Col>
            <Col span={8}>
              <h5>
                Phone Number:{" "}
                {vendorDetails ? vendorDetails.userPhoneNumber : ""}
              </h5>
            </Col>
          </Row>
          <MaterialTable
            columns={columns}
            title="Vendor details"
            isLoading={isLoading}
            icons={tableIcons}
            data={billDetails}
            options={{
              pageSize: 10,
              emptyRowsWhenPaging: true,
              pageSizeOptions: [5, 10, 20, 50, 100, 500],
              search: false,
            }}
            components={{
              Pagination: PatchedPagination,
            }}
          />
        </div> */}
      </div>
      <Modal
        show={cancelBillModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setCancelBillModal(false);
        }}
      >
        <Modal.Header closeButton>
          <div>
            <h3 style={{ color: "#EF4667" }}>Cancel Bill</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-7">
                <div className="row">
                  <br />
                  <div className="col-8">
                    <Form.Control
                      as="select"
                      value={reasonForCancellation}
                      onChange={(e) => setReasonForCancellation(e.target.value)}
                    >
                      <option value="" disabled>
                        Choose cancellation reason
                      </option>
                      <option value="Duplicate invoice number">
                        Duplicate invoice number
                      </option>
                      <option value="Order Cancellation">
                        Order Cancellation
                      </option>
                      <option value="Others">Others</option>
                    </Form.Control>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: 15 }}></div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="cancelButton"
            style={{
              border: "0",
              fontSize: "18px",
              backgroundColor: "transparent",
              color: "#5194c6",
            }}
            onClick={() => {
              setCancelBillModal(false);
              //setCancelType("");
            }}
          >
            Cancel{" "}
          </button>
          <button
            className="addAddrButton"
            disabled={isLoading}
            style={{
              border: "0",
              backgroundColor: "#ef4667",
              color: "#fff",
              fontSize: "15px",
              fontWeight: "600",
              borderRadius: "6px",
              padding: "10px 14px",
            }}
            onClick={() => cancelBill()}
          >
            Cancel Bill
          </button>
        </Modal.Footer>
      </Modal>
      <AntdModal
        onCancel={() => {
          setOpenModal({
            show: false,
            data: {},
          });
        }}
        footer={false}
        width={600}
        open={openModal.show}
        centered
      >
        <div>
          <div className="clearCreditMain">
            <div className="balanceAmountContainer">
              <div
                style={{
                  paddingInline: "45px",
                }}
                className="creditbalanceamount"
              >
                <Text strong style={{ color: "#208441", fontSize: 18 }}>
                  Pending Amount
                </Text>
                <div style={{ color: "#208441", fontWeight: "600" }}>
                  {currencyFormatter(
                    openModal.data.balanceAmount -
                      (parseFloat(paymentMethod.cash) || 0) -
                      (parseFloat(paymentMethod.card) || 0) -
                      (parseFloat(paymentMethod.upi) || 0)
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                marginLeft: "20px",
              }}
              className="payCreditAmountContainer"
            >
              <div className="clearcredittextfields">
                <div className="cashSection">
                  <TextField
                    id="cashAmount"
                    size="small"
                    label="cash"
                    variant="outlined"
                    style={{ width: "280px" }}
                    value={paymentMethod.cash}
                    onChange={(e) => {
                      setPaymentMethod((prev) => {
                        return {
                          ...prev,
                          cash: e.target.value,
                        };
                      });
                    }}
                    placeholder="Cash Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {country.CurrencySymbol}
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="upiSection">
                  <TextField
                    id="upiAmount"
                    size="small"
                    label="Upi"
                    variant="outlined"
                    value={paymentMethod.upi}
                    style={{ width: "280px" }}
                    onChange={(e) => {
                      setPaymentMethod((prev) => {
                        return {
                          ...prev,
                          upi: e.target.value,
                        };
                      });
                    }}
                    placeholder="Upi Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">UPI</InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="cardSection">
                  <TextField
                    id="cardAmount"
                    size="small"
                    label="card"
                    variant="outlined"
                    style={{ width: "280px" }}
                    value={paymentMethod.card}
                    onChange={(e) =>
                      setPaymentMethod((prev) => {
                        return {
                          ...prev,
                          card: e.target.value,
                        };
                      })
                    }
                    placeholder="Card Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <BsCreditCard />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className="chooseCardTypeSection">
                    <div>
                      <select
                        value={cardType}
                        className="selectOfChooseCardType"
                        style={{ width: "130px" }}
                        onChange={(e) => setCardType(e.target.value)}
                      >
                        <option value="" disabled>
                          card type
                        </option>
                        <option value="visa">Visa</option>
                        <option value="masterCard">Master Card</option>
                        <option value="rupay">Rupay</option>
                      </select>
                    </div>
                    <div>
                      <input
                        style={{ width: "130px" }}
                        type="number"
                        className="inputOfChooseCardType"
                        value={cardNumber}
                        onChange={(e) =>
                          setCardNumber(e.target.value.slice(0, 4))
                        }
                        placeholder="Enter last 4 digit"
                        maxLength={4}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                {/* {!billLoading ? ( */}
                <div style={{ textAlign: "center" }}>
                  {/* <button
                    disabled={billLoading}
                    onClick={() => resetToDefault()}
                  >
                    Cancel
                  </button> */}
                  <button
                    className="confirmBillNew"
                    disabled={loading}
                    onClick={handleConfirm}
                  >
                    Confirm
                  </button>
                </div>
                {/* ) : (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "20px 0px 20px 0px",
                    }}
                  >
                    <Spinner animation="border" variant="secondary" />
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </AntdModal>
      <Modal centered show={openHistory.show}>
        <Modal.Header>
          <Title
            style={{
              marginBottom: 0,
            }}
            level={4}
          >
            Pending clear history
          </Title>
        </Modal.Header>
        <Modal.Body>
          {console.log("clearPendingHistory", openHistory.data)}
          <div>
            {Object.hasOwn(openHistory.data, "clearPendingHistory") ? (
              <div>
                {openHistory.data.clearPendingHistory.length > 0 ? (
                  <>
                    {openHistory.data.clearPendingHistory.map((data) => {
                      // console.log("DATA LOADED", data);
                      var paidUsing = "";
                      if (Array.isArray(data.paymentMethod)) {
                        var response = data.paymentMethod.map((val) => {
                          return `${val.method} ( ${currencyFormatter(
                            val.amountPaid
                          )})`;
                        });

                        paidUsing = response.toString();

                        // console.log("Paid Using when array", paidUsing);
                      } else {
                        paidUsing = data.paymentMethod;
                        // console.log("Paid Using when string", paidUsing);
                      }
                      return (
                        <>
                          {paidUsing ? (
                            <p>
                              Cleared Pending Amount of {country.CurrencySymbol}
                              {data.amountPaid} on {data.updatedDate}{" "}
                              {data.updatedTime} via {paidUsing} by{" "}
                              {data.updatedBy} (
                              {data.updatedBy === shopData.phoneNumber
                                ? "You"
                                : data.updatedByName}
                              ). Pending Amount:{country.CurrencySymbol}
                              {data.balanceAmount}
                            </p>
                          ) : (
                            <p>
                              Cleared Pending Amount of {country.CurrencySymbol}
                              {data.amountPaid} on {data.updatedDate}{" "}
                              {data.updatedTime},Nothing is cleared from this
                              bill.
                            </p>
                          )}
                          <hr />
                        </>
                      );
                    })}
                  </>
                ) : (
                  <>No history found!...</>
                )}
              </div>
            ) : (
              <Text>No history found!...</Text>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setOpenHistory({
                show: false,
                data: {},
              });
            }}
            ghost
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VendorBillHistory;
